import { useMutation } from '@tanstack/react-query';

import { useHttpClient, type HttpResponse } from '@bonusly/http-client';

import { ResourcePath } from '../../../hooks/resource-path';
import { MutationOptions } from '../../../hooks/types';
import { pathWithId } from '../../../utils/api';

export interface BonusCancelPendingInviteArgs {
	id: string;
}

export const useCancelPendingInvite = (options: MutationOptions<BonusCancelPendingInviteArgs, HttpResponse<unknown>> = {}) => {
	const http = useHttpClient('v2');

	return useMutation(({ id }: BonusCancelPendingInviteArgs) => {
		return http.post(`${pathWithId(ResourcePath.Bonus, id)}/cancel_pending_invite`, {});
	}, options);
};
